export default "__VITE_ASSET__B0PY6k08__"